// extracted by mini-css-extract-plugin
export default {"eventPage":"eventPage__aQd4Ib","mainCard":"mainCard__csSbn9","menu":"menu__JpttzA","columns":"columns__H47DzX"};